import { getTranslate } from 'react-localize-redux'
import { getUrlParameterByName } from '../../utils'
import { useContext, useEffect, useState } from 'react'
import Loading from '../../HOC/Loading'
import { connect } from 'react-redux'
import Error500 from './Error500'
import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-solid-svg-icons'
import AnonymousFormWrapper from '../../Components/shared/AnonymousFormWrapper'
import ProfileSelection from '../../Components/anonymous/ProfileSelection'
import { AuthContext } from '../../Providers/AuthProvider'

const mapStateToProps = state => ({
  t: getTranslate(state.locale)
})

const AuthCallback = ({ t, onGetUserContextAndData, onAfterLogin }) => {
  const code = getUrlParameterByName('code')
  const [error, setError] = useState(false)
  // For an external account, the backend now binds the token to the FIRST profile on the very first
  // exchange (the PKCE code is single-use, so a second exchange at step 2 would fail): login-sso
  // therefore never returns a NON-empty list here. This state only ever holds an EMPTY list (an
  // external account with no active profile) → ProfileSelection shows the "inactive account" screen.
  const [profiles, setProfiles] = useState(null)

  const { authCallback, navigateToLoginPage } = useContext(AuthContext)

  useEffect(() => {
    if (code) {
      authCallback(code, onGetUserContextAndData, onAfterLogin)
        .then(accountProfiles => {
          if (accountProfiles) {
            setProfiles(accountProfiles)
          }
        })
        .catch(() => setError(true))
    }
  }, [code, authCallback])

  if (!code || error) {
    console.error('Missing authorization code')

    return (
      <AnonymousFormWrapper
        noBgImg
      >
        <Error500
          extra={
            <Button type='primary' icon={<FontAwesomeIcon icon={faLock} />} onClick={() => navigateToLoginPage()}>
              {t('auth.go_to_login_page')}
            </Button>
          }
        />
      </AnonymousFormWrapper>
    )
  }

  if (profiles !== null) {
    return (
      <AnonymousFormWrapper noBgImg>
        <ProfileSelection
          profiles={profiles}
          onBack={() => navigateToLoginPage()}
        />
      </AnonymousFormWrapper>
    )
  }

  return (
    <AnonymousFormWrapper
      noBgImg
    >
      <Loading
        loading
        size='5x'
      />
    </AnonymousFormWrapper>
  )
}
export default connect(mapStateToProps)(AuthCallback)
